import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/styles'
import { Translation } from 'react-i18next'
import WorkshiftRowContainer from '../../../containers/employer/workshifts/workshiftRow.container'
import WorkshiftFormContainer from '../../../containers/employer/workshifts/workshiftForm.container'
import {
  Button,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core'
import SnackbarComponent from '../../../utils/employer/snackbarComponent.utils'
import ExpandablePanel from '../../../utils/expandablePanel'
import ReactPaginate from 'react-paginate'
import mobileView from '../../../utils/mobile.utils'
import { searchWorkshifts } from '../../../utils/openForWork.utils'
import ModalComponent from '../../layout/modal.component'
import { WorkshiftFilters } from '../../../utils/employer/workshift.utils'
import { useNavigationPrompt } from '../../../NavigationPromptProvider'

/**
 * @author Huong Nguyen
 */

class WorkshiftsComponent extends React.Component {
  componentDidMount() {
    this.props.getSignedLE()
    this.props.getTotalApplications()
    this.props.getWorkshifts()
    this.props.getBillableHours()
    this.props.loadProfileStart()
  }

  render() {
    return <Workshifts {...this.props} />
  }
}

const styles = (theme) => ({
  root: {
    width: '100%',
    overflowX: 'auto',
    '&::-webkit-scrollbar': {
      width: '12px !important',
      webkitOverflowScrolling: 'auto !important'
    },

    '&::-webkit-scrollbar-track': {
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3) !important',
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important'
    },

    '&::-webkit-scrollbar-thumb': {
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important',
      background: '#41617D !important',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.5) !important'
    },

    '&::-webkit-scrollbar-thumb:window-inactive': {
      background: '#41617D !important'
    }
  },
  select: {
    lineHeight: '1',
    fontSize: '14px',
    outline: 'none',
    marginBottom: '6px',
    cursor: 'pointer',
    width: '300px',
    backgroundColor: 'white'
  },
  tableHead: {
    fontSize: '13px',
    fontWeight: 'bold',
    borderBottom: '1px solid gray'
  },
  searchField: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  button: {
    margin: 15
  },
  buttonAdd: {
    marginTop: '25px'
  },
  textField: {
    marginTop: theme.spacing(3),
    border: '1px solid gray',
    fontSize: '14px'
  },
  resize: {
    fontSize: '13px'
  },
  checkbox: {
    fontSize: '14px',
    margin: '0px',
    color: '#808080',
    fontWeight: 500
  },
  searchField: {
    display: 'flex',
    flexFlow: mobileView ? 'column' : 'row',
    justifyContent: 'space-between'
  },
  filterFields: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: '0px 8px 30px',
    alignItems: 'flex-end',
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      flexDirection: 'column',
      padding: '0px 8px 30px',
      alignItems: 'stretch'
    }
  },
  table: {
    fontSize: '13px',
    borderTop: '2px solid #999'
  },
  clearFieldButton: {
    position: 'absolute',
    marginLeft: '-36px',
    marginRight: '4px',
    marginTop: '40px',
    alignSelf: 'flex-end',
    height: '32px',
    width: '32px'
  },
  clearIcon: {
    height: '18px',
    width: '18px'
  }
})

const defaultValues = {
  name: '',
  email: '',
  workshift_date: null,
  status: '',
  pinned: false,
  pageSize: 10
}

const statusOptions = [
  { value: '', label: '' },
  { value: 0, label: 'employer.ws_status.0' },
  { value: 2, label: 'employer.ws_status.2' },
  { value: 3, label: 'employer.ws_status.3' },
  { value: 4, label: 'employer.ws_status.4' },
  { value: 1, label: 'employer.ws_status.5' },
  { value: 6, label: 'employer.ws_status.6' }
]

const Workshifts = ({
  classes,
  workshiftData,
  showAddSnackbar,
  showFailedAddSnackbar,
  showEditSnackbar,
  showFailedEditSnackbar,
  closeWorkShiftSnackbar,
  showWorkshiftFormDialog,
  closeWorkshiftFormDialog,
  showWorkshiftForm,
  cancelEditWorkShift
}) => {
  const { confirmAction } = useNavigationPrompt()
  const [searchWorkshiftValues, setSearchWorkshiftValues] =
    React.useState(defaultValues)
  const [page, setPage] = React.useState(0)

  const filteredWorkshiftRows = searchWorkshifts(
    workshiftData,
    searchWorkshiftValues
  )
  const groupedWorkshiftRows = groupWorkshiftByEmail(filteredWorkshiftRows)

  return (
    <Translation>
      {(t) => {
        return (
          <div className="container">
            <div className="pull-right" style={{ paddingBottom: '15px' }}>
              <Button
                variant="contained"
                className={classes.buttonAdd}
                onClick={() => {
                  showWorkshiftFormDialog()
                }}
              >
                {t('employer.workshifts.h1c')}
              </Button>
            </div>
            <div className="row">
              <div className="dashboard-content-header">
                <div className="col-xs-12 col-sm-12 col-lg-12">
                  <ExpandablePanel
                    title={t('employer.workshifts.h3')}
                    renderBody={() => (
                      <div className={classes.root}>
                        <WorkshiftFilters
                          t={t}
                          filters={searchWorkshiftValues}
                          onChange={setSearchWorkshiftValues}
                          classes={classes}
                          statusOptions={statusOptions}
                          resetSelectedPage={() => setPage(0)}
                        />
                        <Table
                          className={classes.table}
                          aria-labelledby="tableTitle"
                          aria-label="enhanced table"
                        >
                          <TableHead>
                            <TableRow>
                              <TableCell className={classes.tableHead}>
                                {t('employer.workshifts.col2')}
                              </TableCell>
                              <TableCell className={classes.tableHead}>
                                {t('employer.workshifts.col15')}
                              </TableCell>
                              <TableCell
                                className={classes.tableHead}
                                colSpan={2}
                              >
                                {t('employer.workshifts.col16')}
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {workShiftRow(
                              t,
                              classes,
                              groupedWorkshiftRows,
                              page,
                              searchWorkshiftValues.pageSize
                            )}
                          </TableBody>
                        </Table>
                        <Divider />
                        <div className="panel-body">
                          {groupedWorkshiftRows.length > 0 ? (
                            <ReactPaginate
                              previousLabel={
                                <i className="fa fa-chevron-left" />
                              }
                              nextLabel={<i className="fa fa-chevron-right" />}
                              breakLabel={'...'}
                              breakClassName={'break-me'}
                              pageCount={
                                !!groupedWorkshiftRows
                                  ? Math.ceil(
                                      groupedWorkshiftRows.length /
                                        searchWorkshiftValues.pageSize
                                    )
                                  : 0
                              }
                              marginPagesDisplayed={2}
                              pageRangeDisplayed={5}
                              onPageChange={(event) => {
                                setPage(event.selected)
                              }}
                              containerClassName={'pagination'}
                              subContainerClassName={'pages pagination'}
                              activeClassName={'active'}
                              forcePage={page}
                            />
                          ) : (
                            <div style={{ padding: '20px' }}></div>
                          )}
                        </div>
                      </div>
                    )}
                    defaultExpanded={true}
                  />
                </div>
              </div>
            </div>
            <ModalComponent
              onClose={() => {
                confirmAction('', () => {
                  closeWorkshiftFormDialog()
                  cancelEditWorkShift()
                })
              }}
              open={showWorkshiftForm}
              maxWidth="1440px"
              content={<WorkshiftFormContainer />}
              isFullScreen={mobileView}
            />
            <SnackbarComponent
              open={showAddSnackbar}
              message={t('employer.workshifts.msg1')}
              variant="success"
              autoHideDuration={3000}
              onClose={closeWorkShiftSnackbar}
            />
            <SnackbarComponent
              open={showFailedAddSnackbar}
              message={t('employer.workshifts.msg2')}
              variant="error"
              autoHideDuration={3000}
              onClose={closeWorkShiftSnackbar}
            />
            <SnackbarComponent
              open={showEditSnackbar}
              message={t('employer.workshifts.msg3')}
              variant="success"
              autoHideDuration={3000}
              onClose={closeWorkShiftSnackbar}
            />
            <SnackbarComponent
              open={showFailedEditSnackbar}
              message={t('employer.workshifts.msg4')}
              variant="error"
              autoHideDuration={3000}
              onClose={closeWorkShiftSnackbar}
            />
          </div>
        )
      }}
    </Translation>
  )
}
const groupWorkshiftByEmail = (workshifts) => {
  return Object.values(
    workshifts.reduce((acc, workshift) => {
      const key = workshift.offershift_to
      if (!acc[key]) {
        acc[key] = {
          offered_to: workshift.offershift_to,
          name: workshift.firstname + ' ' + workshift.lastname,
          workshifts: []
        }
      }
      acc[key].workshifts.push(workshift)
      return acc
    }, {})
  )
}

const workShiftRow = (t, classes, workShiftRowData, selected, pageSize) => {
  return workShiftRowData
    .slice(selected * pageSize, selected * pageSize + pageSize)
    .map((el, index) => (
      <WorkshiftRowContainer index={index} key={el.offered_to} shiftData={el} />
    ))
}

export const extractTextFromHTML = (htmlData) => {
  const tempElement = document.createElement('div')
  tempElement.innerHTML = htmlData
  return tempElement.textContent
}

WorkshiftsComponent.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(WorkshiftsComponent)
